<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        ประวัติการเข้าใช้งาน (Access Logs)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>ประวัติการเข้าใช้งาน (Access Logs)
          </a>
        </li>
        <li class="active">ประวัติการเข้าใช้งาน</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="wrapper_uploadsave">
                    <el-form size="mini">
                      <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="คำค้นหา">
                                  <el-input v-model="form.wording" placeholder="กรุณากรอกคำค้นหา เช่น ชื่อ - นามสกุล หรือ เบอร์โทรศัพท์" clearable></el-input>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                                <el-form-item label="ประเภทผู้เข้าใช้งาน">
                                <el-select 
                                    v-model="form.user_type" 
                                    placeholder="กรุณาเลือกประเภทของผู้เข้าใช้งาน">
                                    <el-option label="ทั้งหมด" value=""></el-option>
                                    <el-option label="ผู้ดูแลระบบ" value="admin"></el-option>
                                    <el-option label="ผู้ให้บริการ" value="operator"></el-option>
                                    <el-option label="ผู้ใช้งานทั่วไป" value="user"></el-option>
                                </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-sm-6">
                                <el-form-item label="ช่วงเวลาที่เข้าใช้งาน">
                                    <el-date-picker
                                        v-model="form.daterange"
                                        type="daterange"
                                        range-separator="ถึง"
                                        start-placeholder="วันที่เริ่มต้น"
                                        end-placeholder="วันที่สิ้นสุด"
                                        placeholder="ช่วงเวลาที่เข้าใช้งาน"
                                    ></el-date-picker>
                                </el-form-item>
                            </div>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <el-button class="btn btn-primary" @click="search({page: 1 , pageSize : 10})">ค้นหา</el-button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="tablelist">
                  <data-tables-server 
                  @query-change="search"
                    :data="access_log_list" 
                    :total="access_log_total"
                    :current-page.sync="form.page"
                    :page-size="form.pageSize"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    style="width: 100%">
                    <el-table-column v-if="user_type !== 'user'" sortable prop="fullname" label="ชื่อ - นามสกุล"></el-table-column>
                    <el-table-column sortable prop="phone_number" label="เบอร์โทรศัพท์"></el-table-column>
                    <el-table-column sortable prop="ip_address" label="IP Address"></el-table-column>
                    <el-table-column sortable prop="user_agent" label="User Agent"></el-table-column>
                    <el-table-column sortable prop="type" label="ประเภท"></el-table-column>
                    <el-table-column prop="is_login" label="การทำงาน">
                      <template slot-scope="scope">
                        {{ scope.row.is_login ? 'เข้าสู่ระบบ' : 'ออกจากระบบ' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="status" label="สถานะ">
                      <template slot-scope="scope">
                        {{ scope.row.status ? 'สำเร็จ' : 'ล้มเหลว' }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="create_at" label="วันที่เข้าใช้งาน"></el-table-column>
                  </data-tables-server>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import {mapState,mapActions} from "vuex"
import config from "../../../config/config";
export default {
  created() {
    const regex = /Operator/;
    var currentPath = this.$router.currentRoute.path;
    if (regex.test(currentPath)) {
      this.checkPermission = true;
    }
  },
  data() {
    return {
      checkPermission: false,
      form: {
        wording: null,
        user_type : null,
        daterange: [],
        page : 1,
        pageSize : 10,
        sort: {
          order: null,
          prop: null
        }
      },
      selectDate: "",
      tableProps: {
        border: true
        // stripe: true,
      },
      url : config.API_URL,
      user_type : ""
    };
  },
  computed: {
    ...mapState({
      access_log_list : store=> store.Manage_user.access_log_list,
      access_log_total : store => store.Manage_user.total,
      loading : store => store.Manage_user.loading
    })
  },
  methods: {
    ...mapActions({
      getAccessLog : "Manage_user/getAccessLog"
    }),
    search(queryInfo){
      let formdata = Object.assign(this.form, queryInfo)
      this.getAccessLog(this.form)
      this.user_type = this.form.user_type
    },
    change_provider_type(){
      this.options = this.form.provider_type == '' ? this.provider_list : this.provider_list.filter(item => item.provider_type == this.form.provider_type) 
    }
  }
};
</script>
